import { LoadingButton } from "@altimateai/lego";
import ProfileImageByUser from "../../user/ProfileImageByUser";
import { User } from "../../user/types";
import MentionsInputComponent from "./mentions/MentionsInput";
import classes from "../details/styles.module.scss";
import { AskIcon } from "../../../assets/icons";

interface Props {
  comment: string;
  setComment: (comment: string) => void;
  loading: boolean;
  users: User[];
  currentUser: User | null;
  placeholder?: string;
  onEnterKeypress?: () => void;
}
const ConversationInputForm = ({
  comment,
  setComment,
  loading,
  users,
  currentUser,
  placeholder,
  onEnterKeypress,
}: Props) => {
  return (
    <div className={classes.conversationInputForm}>
      {currentUser ? <ProfileImageByUser user={currentUser} /> : null}
      <MentionsInputComponent
        value={comment}
        setValue={setComment}
        users={users}
        placeholder={placeholder}
        onEnterKeypress={onEnterKeypress}
      />
      <LoadingButton loading={loading} color="primary">
        <AskIcon />
      </LoadingButton>
    </div>
  );
};

export default ConversationInputForm;
